<template>
  <!-- Vuetify 2 has no date-time picker, so this shows v-date-picker first and
       v-time-picker once a date is picked. v-model is "YYYY-MM-DDTHH:mm" (local time);
       the field shows "dd-mm-yyyy HH:mm". -->
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template #activator="{ on, attrs }">
      <v-text-field
        :value="displayValue"
        :label="label"
        :rules="rules"
        :error-messages="errorMessages"
        :hint="hint"
        :persistent-hint="!!hint"
        :clearable="clearable"
        placeholder="dd-mm-yyyy hh:mm"
        prepend-inner-icon="mdi-calendar-clock"
        outlined
        dense
        readonly
        v-bind="attrs"
        v-on="on"
        @click:clear="$emit('input', '')"
      />
    </template>

    <v-card class="dtp-card">
      <v-date-picker
        v-if="step === 'date'"
        v-model="date"
        :min="min"
        no-title
        scrollable
        width="290"
        @input="step = 'time'"
      />

      <template v-else>
        <div class="dtp-head">
          <v-btn icon x-small @click="step = 'date'">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <span class="dtp-date" @click="step = 'date'">{{ formatDate(date) }}</span>
          <v-spacer />
          <span class="dtp-time">{{ time || "--:--" }}</span>
        </div>
        <v-time-picker
          v-model="time"
          format="24hr"
          no-title
          scrollable
          width="290"
        />
        <v-card-actions class="pt-0">
          <v-spacer />
          <v-btn text x-small @click="menu = false">Cancel</v-btn>
          <v-btn x-small class="accent white--text" :disabled="!time" @click="confirm">
            OK
          </v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: "DateTimePicker",

  props: {
    value: { type: String, default: "" },
    label: { type: String, default: "" },
    rules: { type: Array, default: () => [] },
    errorMessages: { type: [String, Array], default: () => [] },
    hint: { type: String, default: "" },
    clearable: { type: Boolean, default: false },
    // earliest selectable date, "YYYY-MM-DD"
    min: { type: String, default: undefined },
  },

  data() {
    return { menu: false, step: "date", date: "", time: "" };
  },

  computed: {
    displayValue() {
      if (!this.value) return "";
      const [date, time] = this.value.split("T");
      return `${this.formatDate(date)} ${time.slice(0, 5)}`;
    },
  },

  watch: {
    // Load the current value each time the menu opens, so Cancel discards changes.
    menu(open) {
      if (!open) return;
      const [date, time] = (this.value || "").split("T");
      this.date = date || "";
      this.time = time ? time.slice(0, 5) : "";
      this.step = "date";
    },
  },

  methods: {
    confirm() {
      this.$emit("input", `${this.date}T${this.time}`);
      this.menu = false;
    },

    // "2026-10-27" -> "27-10-2026"
    formatDate(date) {
      const [y, m, d] = date.split("-");
      return `${d}-${m}-${y}`;
    },
  },
};
</script>

<style scoped>
.dtp-card {
  width: 290px;
}
.dtp-head {
  display: flex;
  align-items: center;
  padding: 6px 10px 0 4px;
  font-size: 13px;
}
.dtp-date {
  cursor: pointer;
  font-weight: 500;
}
.dtp-time {
  font-weight: 600;
  color: var(--v-accent-base);
}
</style>
